import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type ContentHeaderPersonFragment = {
	__typename?: 'Person';
	id: string;
	content: {
		__typename?: 'PersonContent';
		fullName: string;
		shortDescription?: string | null;
		dateOfBirth?: any | null;
	};
};

export const ContentHeaderPersonFragmentDoc = gql`
	fragment ContentHeaderPerson on Person {
		id
		content(country: $country, language: $language) {
			fullName
			shortDescription
			dateOfBirth
		}
	}
`;
